module.exports = __webpack_public_path__ + "img/2023-12.36ff4fe3.jpg";